<emperor-dialog
  *ngIf="this.shouldDisplayDialog$ | async"
  [backdropDismiss]="false"
>
  <emperor-card-header [color]="theme">
    We're having trouble with our connection.
  </emperor-card-header>

  <p>
    Please wait while we try to reconnect, or you can try refreshing the page.
  </p>

  <emperor-spinner [diameter]="40"></emperor-spinner>
</emperor-dialog>
